import { render } from "./Cost.vue?vue&type=template&id=d10bb064&scoped=true"
import script from "./Cost.vue?vue&type=script&lang=js"
export * from "./Cost.vue?vue&type=script&lang=js"

import "./Cost.vue?vue&type=style&index=0&id=d10bb064&lang=less&scoped=true"

import exportComponent from "/root/workspace/school-mobile_yvTP/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d10bb064"]])

export default __exports__